/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Features_Item_5_DescInputs */

const es_home_features_item_5_desc = /** @type {(inputs: Home_Features_Item_5_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso controlado por permisos y scopes específicos por usuario.`)
};

const en_home_features_item_5_desc = /** @type {(inputs: Home_Features_Item_5_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access controlled by user-specific permissions and scopes.`)
};

/**
* | output |
* | --- |
* | "Access controlled by user-specific permissions and scopes." |
*
* @param {Home_Features_Item_5_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_features_item_5_desc = /** @type {((inputs?: Home_Features_Item_5_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Features_Item_5_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_features_item_5_desc(inputs)
	return en_home_features_item_5_desc(inputs)
});
export { home_features_item_5_desc as "home.features.item_5_desc" }